import { TKeys } from './types'

export const ar_ma: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // SCREENS
    // General
    loading: 'جاري التحميل...',
    // SignIn
    signin_title: 'تسجيل الدخول',
    signin_redirect_title: 'تحقق من اسم المستخدم وكلمة المرور',
    psw_placeholder_redirect: 'تأكيد كلمة المرور',
    psw_placeholder: 'كلمة المرور',
    email_placeholder: 'البريد الإلكتروني',
    language: 'اللغة',
    forgot_password: 'هل نسيت كلمة المرور؟',
    signup_hint: 'ليس لديك حساب؟ سجل الآن',
    btn_signin: 'تسجيل الدخول',
    // Intro
    // N-Ary sort
    my_profile: 'ملفي الشخصي',
    btn_submit: 'تأكيد',
    btn_finish: 'إنهاء',
    hint_undo: 'هل أنت متأكد من أنك تريد إلغاء الإجراء الأخير؟',
    // Global screen
    tip_quit: 'هل أنت متأكد من أنك تريد الخروج؟',
    // State screen
    intro_title: 'السعادة هي مفتاح النجاح',
    intro_body:
        'إذا أحببت ما تفعله والفريق الذي تعمل معه، فسوف تنجح في حياتك المهنية.',
    howto1_title: `سوف ترى عبارتين من العبارات
    
    اضغط على الذي تفضله

    لن يستغرق ذلك سوى 12 دقيقة`,
    howto1_body:
        'نوصي بإجراء هذا الاختبار في بيئة هادئة. إذا لزم الأمر، قم بإجرائه في وقت لاحق.',
    award1_title: 'لقد أنهيت المرحلة الأولى، أحسنت!',
    award1_body:
        'في أعلى الصفحة التالية، ستجد ما تعتبره الأكثر أهمية في بيئة عملك المثالية. تحقق من أنه يتوافق مع تفضيلاتك، وإذا لزم الأمر، أعد ترتيب هذه العبارات عن طريق السحب والإفلات.',
    award2_title: 'لقد قطعت أكثر من نصف الطريق!',
    award2_body:
        'العبارات الأكثر أهمية موجودة في قمة الصفحة التالية. تحقق من الترتيب، وإذا لزم الأمر، أعد ترتيبها عن طريق السحب والإفلات.',
    award3_title: 'تهانينا على إكمال الجزء الثالث',
    award3_body: 'لقد أوشكت على الانتهاء! أكمل بأمانة وصراحة!',
    howto2_title: 'والآن الأسئلة الأخيرة - +/- 2 دقائق',
    howto2_body:
        'هل يمكنك ترتيب العبارات التالية من الأهم (في الأعلى) إلى الأقل أهمية (في الأسفل).',
    title_rank: 'في بيئة عملي **المثالية**،',
    subtitle_rank_2: 'الأهم هو',
    subtitle_rank_n: 'البيان التالي أكثر أو أقل أهمية؟',
    hint_reorder: 'أعد الترتيب إذا لزم الأمر من الأهم إلى الأقل أهمية',
    hint_overview: 'انقر أدناه لرؤية الملخص',
    hint_profile: 'تفضيلاتي الحالية',
    hint_place_below: 'ضع البيان أدناه',
    title_rank_bucket: 'المقارنات الأخيرة تمامًا',
    subtitle_rank_best: 'هذه المرة، ما هو الأكثر أهمية بالنسبة لك؟',
    subtitle_rank_least: 'ما هو الأقل أهمية بالنسبة لك؟',
    subtitle_rank_reorder: 'أعد الترتيب، من الأكثر إلى الأقل أهمية',
    title_thanks: 'شكرًا لمشاركتك!',
    hint_thanks: 'شكرًا! تم إرسال ملفك الشخصي بنجاح إلى فرقنا.',
    title_error: 'تعذر إرسال الملف الشخصي',
    hint_error: 'يرجى المحاولة مرة أخرى لاحقًا...',
    hint_error_validation:
        'خطأ في التحقق من البيانات، يرجى المحاولة مرة أخرى لاحقًا',
    hint_error_dup: 'لقد أرسلت تقريرًا سابقًا بالفعل.',
    hint_confirm_round: 'هل أنت متأكد من أنك تريد تأكيد هذا الترتيب؟',
    retry_btn: 'أعد المحاولة',
    btn_to_overview: 'الملخص',
    btn_to_bucket_x: 'المجموعة',
    btn_to_params: 'الإعدادات',
    btn_open: 'فتح',
    btn_start: 'ابدأ',
    btn_confirm: 'تأكيد',
    // btn_next: 'التالي',
    btn_next: '>',
    btn_next_str: 'التالي',
    btn_next_round: 'المرحلة التالية',
    // 'btn_prev': 'السابق',
    btn_prev: '<',
    btn_cancel: 'إلغاء',
    // 'btn_back': 'العودة',
    btn_back: '<',
    btn_download: 'تحميل تقريرك',
    btn_quit: 'الخروج',
    // Comparaisons
    pick_best: 'ما هو الأكثر أهمية بالنسبة لك؟',
    pick_worst: 'ما هو الأقل أهمية بالنسبة لك؟',
    vs: 'أو',
    // UI elements
    round: 'مرحلة',
    stm: 'بيان',
    bucket: 'مجموعة',
    axis_y: 'عدد العبارات',
    tip_saved: 'تم الحفظ',
    top_scale_hint: 'الأكثر أهمية',
    bottom_scale_hint: 'الأقل أهمية',
    pick_tip: 'اختر!',
    how_to_binary_title: 'تعليمات',
    // values
    samen: 'التعاون',
    conf: 'الامتثال',
    erken: 'تعرُّف',
    zorg: 'الرعاية',
    gelijk: 'المساواة والتنوع',
    zelfsturing: 'الاستقلالية',
    macht: 'القوة',
    voorspelbaar: 'القدرة على التنبؤ',
    prestatie: 'الأداء',
    zelfontplooi: 'التطوير الشخصي',
    duurzaam: 'الاستدامة',
    integriteit: 'النزاهة',
    innovatie: 'الابتكار',
    daadkracht: 'القوة',
    //
    no_slug_error: 'يرجى التحقق من صحة الرابط، أو الاتصال بالمشرف/الدعم الفني',
    unknown_error: 'حدث خطأ، يرجى المحاولة مرة أخرى لاحقًا',
    invalid_credentials: 'البريد الإلكتروني / كلمة المرور غير صحيحة',
    // 360:
    // TLTM Scale
    lvl0: 'يرجى الاختيار',
    lvl1: 'قليل جدًا',
    lvl2: 'قليل',
    lvl3: 'أقل قليلاً',
    lvl4: 'كافٍ تمامًا',
    lvl5: 'أكثر قليلاً',
    lvl6: 'كثير',
    lvl7: 'كثير جدًا',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'كافٍ تمامًا',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'يرجى الاختيار',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'أبدًا',
    lvlSC10x0: 'عديم الفائدة',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'مفقود',
    lvlSC10x1: 'سيء للغاية',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'مفقود',
    lvlSC10x2: 'سيء جدًا',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'مفقود',
    lvlSC10x3: 'سيء',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'مفقود',
    lvlSC10x4: 'غير كافٍ',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'مفقود',
    lvlSC10x5: 'متوسط',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'مفقود',
    lvlSC10x6: 'عادي',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'مفقود',
    lvlSC10x7: 'جيد',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'مفقود',
    lvlSC10x8: 'جيد جدًا',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'مفقود',
    lvlSC10x9: 'ممتاز',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'بالتأكيد',
    lvlSC10x10: 'مثالي',
    howto_360_title:
        'كمنظمة، نحن نعير أهمية كبيرة للقيم، ونؤمن أنه من الضروري معرفة ما يجعلك سعيدًا حقًا في بيئة عملك.',
    howto_360_body:
        'سيظل هذا الاستبيان مجهولاً لرؤسائك، حيث سيتلقون النتائج المجملة فقط.',
    picker_360_title_workenv: 'في بيئة عملي الحالية...',
    howto_nps_body: 'على مقياس من 0 إلى 10، ما هو احتمال أن توصي بعملك هنا لأ',
    // missing from AI:
    picker_360_title_leadership: 'مديري المباشر...',
    nps_title: 'إلى أي مدى توصي بالعمل هنا؟',
    comment_title: 'إضافة تعليق',
    comment_placeholder: 'نشكرك على أي تعليق بنّاء (400 حرف)',
    comment_save: 'حفظ وإغلاق',
    comment_remaining: 'عدد الأحرف المتبقية',
    howto_workenv_title: 'شارك الآن انطباعاتك عن بيئة العمل الحالية',
    howto_workenv_body: `كيف تجدها؟ فكر في الإجراءات، الحوكمة، الأنظمة، ...
لا تتردد في ترك تعليق لنا`,
    howto_nps_title: 'هل توصي صاحب العمل الخاص بك كمكان للعمل؟',
    // legacy_v2:
    btn_next_step: 'التالي',
    to_assign: 'لتخصيصه',
    least_important: 'أقل أهمية',
    moderately_important: 'مهم إلى حد ما',
    most_important: 'أهم شيء',
    ranker_title: 'ما هو المهم بالنسبة لك في عملك المثالي؟',
    too_insufficient_warning: 'تحتوي هذه المجموعة على بيانات غير كافية',
    too_much_warning: 'تحتوي هذه المجموعة على العديد من البيانات',
    too_much_warning1:
        'لقد قمت بتخصيص العديد من البيانات للمجموعة(المجموعات) التالية:',
    too_much_warning2:
        'انقر على المجموعة وخصص البيانات إلى مجموعة أخرى حتى تصبح التوزيعة صحيحة',
    empty_bin: 'هذه المجموعة فارغة',
    further_ranking: 'ما هو المهم بالنسبة لك في عملك المثالي؟',
    further_ranking1: '',
    further_ranking2: '',
    hint_modal_title: 'تخيل بيئة العمل المثالية لك',
    hint_modal_body1:
        'رتب 42 بيانًا حول بيئتك المثالية من الأقل إلى الأكثر أهمية',
    hint_modal_body2_left: 'يسار',
    hint_modal_body2_left_txt: 'الـ 11 بيانًا التي تراها أقل أهمية',
    hint_modal_body2_right: 'يمين',
    hint_modal_body2_right_txt: 'الـ 11 بيانًا التي تراها الأكثر أهمية',
    hint_modal_body2_middle: 'وسط',
    hint_modal_body2_middle_txt: 'الـ 20 بيانًا التي تراها مهمة إلى حد ما',
    hint_modal_body3: 'اسحب وأسقط كل بيان في المجموعة التي تناسبك أكثر',
    hint_modal_cta: 'ابدأ',
    hint_top: 'التمرير لأعلى',
    hint_down: 'التمرير لأسفل',
    final_distribution_invalid_title: 'التوزيع النهائي غير صالح',
    final_distribution_invalid_body:
        'هناك {{v1}} صندوق(صناديق) يحتوي على عبارات كثيرة جداً و {{v2}} صندوق(صناديق) يحتوي على عبارات قليلة جداً',
    no_available_bins_warning:
        'لا توجد صناديق متاحة للتعيين العشوائي - لقد وصلت جميع الصناديق إلى أقصى سعتها',
    sort_middle_bucket_title: 'هل ترغب في فرز الصندوق الأوسط؟',
    sort_middle_bucket_body: 'سيؤدي هذا إلى فرز الصندوق الأوسط حسب القيمة.',
    reflect_current_view_title: 'هل يعكس هذا وجهة نظرك الحالية؟',
    reflect_current_view_sort_body:
        'إذا لم يكن الأمر كذلك ، فسيتم عرض فرز ترتيبك النهائي عليك',
    yes: 'نعم',
    no: 'لا',
    final_ranking: 'الترتيب النهائي',
    example: 'مثال :',
}
